import React from 'react';
import { Link } from 'react-scroll';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

const roadmapStages = [
    {
        title: 'BASIC LOGO',
        salePrice: '$118',
        actualPrice: '$59',
        off: '50%',
        items: [
            '2 Logo Design Concepts', '1 Designer', '24 Hours TAT', '2 Design Revisions', 'Dedicated Account Manager'
        ]
    },
    {
        title: 'STARTUP LOGO',
        salePrice: '$238',
        actualPrice: '$119',
        off: '50%',
        items: [
            '4 Logo Design Concepts', '2 Designer', '24 Hours TAT', '4 Design Revisions', 'Dedicated Account Manager'
        ]
    },
    {
        title: 'PROFESSIONAL LOGO',
        salePrice: '$330',
        actualPrice: '$165',
        off: '50%',
        items: [
            '6 Logo Design Concepts', '4 Designer', '48 Hours TAT', '6 Revisions', 'Dedicated Account Manager', 'Business Card Design'
        ]
    },
    {
        title: 'LOGO INFINITE',
        salePrice: '$598',
        actualPrice: '$299',
        off: '50%',
        items: [
            '8 Original Logo Concepts', '8 Dedicated Logo Designers (Industry Specific)', '8 Revisions', 'Stationery Design (Business Card)'
        ]
    },
    {
        title: 'LOGO PLATINUM',
        salePrice: '$998',
        actualPrice: '$499',
        off: '50%',
        items: [
            '10 Logo Concepts', '8 Dedicated Logo Designers (Industry Specific)', '10 Revisions', 'Animated Logo', 'Stationery Design (Business Card)'
        ]
    },
    {
        title: 'LOGO COMBO + FREE WEBSITE',
        salePrice: '$1200',
        actualPrice: '$600',
        off: '50%',
        items: [
            '3 Page Professional Website', '12 Original Logo Concepts', '12 Dedicated Logo Designers (Industry Specific)', '12 Revisions'
        ]
    },
    {
        title: 'ILLUSTRATIVE LOGOew',
        salePrice: '$498',
        actualPrice: '$249',
        off: '50%',
        items: [
            '3 Custom Illustrative Design Concepts', 'By 3 Industry-Based Designers', '3 Revisions', '72 Hours Turnaround Time', '100% Ownership Rights'
        ]
    },
    {
        title: 'CHARACTER ILLUSTRATION',
        salePrice: '$440',
        actualPrice: '$220',
        off: '50%',
        items: [
            '2 Animated Logo Concepts', 'By 3 Industry-Based Designers', '2 Revisions', '5 Business Days Turnaround Time', '100% Ownership Rights'
        ]
    },
    {
        title: 'ANIMATED LOGO',
        salePrice: '$348',
        actualPrice: '$174',
        off: '50%',
        items: [
            '2 Animated Logo Concepts', 'By 2 Industry-Based Designers', '2 Revisions', '5 Business Days Turnaround Time', '100% Ownership Rights'
        ]
    },
];

const Packages = () => {

    return (
        <section id="packages" className="meme_roadmap_section section_space">
            <div className="container">
                <div className="memecoin_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
                    <h2 className="heading_text text-uppercase mb-0">CHOOSE YOUR PLAN</h2>
                </div>

                <div className="meme_roadmap_carousel">
                    <Swiper
                        loop={true}
                        spaceBetween={30}
                        grabCursor={false}
                        centeredSlides={true}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            991: { slidesPerView: 2 },
                            1025: { slidesPerView: 3 },
                            1700: { slidesPerView: 3 },
                        }}
                    >
                        {roadmapStages.map((stage, index) => (
                            <SwiperSlide key={index}>
                                <div className="meme_roadmap_block">
                                    <div className="roadmap_info">
                                        <h3 className="roadmap_title text-uppercase">{stage.title}</h3>
                                        <div className='d-flex gap-3 pb-5 pt-4'>
                                            <p style={{ fontSize: '40px', fontWeight: 'bold' }}>{stage.salePrice}</p>
                                            <p style={{ marginTop: '6px' }}><del>{stage.actualPrice}</del></p>
                                            <p style={{ marginTop: '6px' }}>{stage.off} OFF</p>
                                        </div>
                                        <ul className="iconlist_block unordered_list_block">
                                            {stage.items.map((item, itemIndex) => (
                                                <li key={itemIndex}>
                                                    <span className="iconlist_icon">
                                                        <i className="fa-regular fa-square-check"></i>
                                                    </span>
                                                    <span className="iconlist_label">{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <Link className="memecoin_btn mt-5 px-4 py-3 text-uppercase" style={{ backgroundColor: '#000', borderRadius: '30px', fontSize: '18px', letterSpacing: '1px' }} to="/token">
                                            Order Now
                                        </Link>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Packages;
